const BASE = '/api/bible-notes';

export async function bibleNotesRequest(path = '', options = {}) {
  const token = sessionStorage.getItem('token');
  if (!token) throw new Error('請先登入，才能保存及查看個人聖經筆記。');
  const response = await fetch(`${BASE}${path}`, {
    ...options,
    headers: {
      Authorization: `Bearer ${token}`,
      ...(options.body ? { 'Content-Type': 'application/json' } : {}),
      ...options.headers,
    },
  });
  if (!response.ok) {
    if (response.status === 401) throw new Error('登入已過期，請重新登入。');
    throw new Error(await response.text().catch(() => '') || `操作失敗 (${response.status})`);
  }
  return response.status === 204 ? null : response.json();
}

export function noteReference(note) {
  return `${note.bookName || note.book} ${note.chapter}:${note.startVerse}${note.endVerse > note.startVerse ? `-${note.endVerse}` : ''}`;
}
